import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as Domain from 'esri/layers/support/Domain';
import { forkJoin, of } from 'rxjs';
import { Observable, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { DomainDefinitionService } from '../../../../../builder/services/domain-definition.service';
import { Well } from '../../../../../common/models/well.model';
import { DomainValue } from '../../../../../models/domain.model';
import { PostDrillingConfig } from '../../../../../post-drilling/models/post-drilling.models';
import { AuthService } from '../../../../../services/auth.service';

@Component({
    selector: 'app-user-updates',
    templateUrl: './user-updates.component.html',
    styleUrls: ['./user-updates.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class UserUpdatesComponent extends ApplicationSectionBaseComponent implements OnInit {
    @Input() form: FormGroup;
    @Input() application: WorkflowData;

    @Input() set well(well: Well) {
        this._well = well;
    }

    subscriptions: Subscription = new Subscription;


    get wellSymbolCtrl(): string { //would be more accurate to call this value
        if (this.form.get("wellSymbol").value == null) return "";
        return this.form.get("wellSymbol").value
    }

    get categoryCtrl(): string {
        if (this.form.get("category").value == null) return "";
        return this.form.get("category").value
    }

    get dispositionCtrl(): string {
        if (this.form.get("disposition").value == null) return "";
        return this.form.get("disposition").value
    }

    get legacyTrackingValue(): string {
        if (this.form.get("legacyTracking").value == null) return "";
        return this.form.get("legacyTracking").value
    }

    get dispositionOptions(): DomainValue[] {
        if (this._dispositionOptions == null) return null;
        let sets: DomainValue[] = [];
        sets = this._dispositionOptions.filter(m => m.Code == "DG" || m.Code == "DR" || m.Code == "FR" || m.Code == "PA" || m.Code == "PR"||  m.Code == "ORPH" || m.Code == "UN");
        return sets;
    }
    wellSymbols: DomainValue[];

    _well: Well;

    _categories: DomainValue[];

    _legacyTrackingValues: DomainValue[];
    wellTypeDescriptionDomainValues: DomainValue[];
    wellDispositionLegacyTrackingDomainId: string;
    wellTypeDescriptionDomainId: string;
    _dispositionOptions: DomainValue[];

    wellDispositionDomainValues$: Observable<any>;
    wellDispositionLegacyTrackingDomainValues$: Observable<any>;
    wellTypeDescriptionDomainValues$: Observable<any>;

     
    constructor(auth: AuthService, public domainService: DomainDefinitionService) {
        super(auth);
    }

    ngOnInit() {

        let symObs$ = this.domainService.getValues("WELL_SYMB").pipe();

        let symSub$ = symObs$.subscribe(
            (domainValues: DomainValue[]) => {
                this.wellSymbols = domainValues;
            },
            error => console.error(error)
        )

        this.subscriptions.add(symSub$);

                this.form.get("disposition").setValue(this._well.wellStatus.disposition);
        if (this.application != null) {
            if (this.dispositionCtrl != null) {
                if (this.dispositionCtrl) {
                    switch (this.dispositionCtrl) {
                        case "DG":
                            this.wellDispositionLegacyTrackingDomainId = "WellSpuddedLegacyTrackingOptions";
                            break;
                        case "DR":
                            this.wellDispositionLegacyTrackingDomainId = "WellDrilledLegacyTrackingOptions";
                            break;
                        case "FR":
                            this.wellDispositionLegacyTrackingDomainId = "FinalRestorationLegacyTrackingOptions";
                            break;
                        case "PA":
                            this.wellDispositionLegacyTrackingDomainId = "PluggedLegacyTrackingOptions";
                            break;
                        case "PR":
                            this.wellDispositionLegacyTrackingDomainId = "ProductionStartedLegacyTrackingOptions";
                            break;
                        case "ORPH":
                            this.wellDispositionLegacyTrackingDomainId = "OrphanLegacyTrackingOptions";
                            break;
                        case "UN":
                            this.wellDispositionLegacyTrackingDomainId = "UnknownLegacyTrackingOptions";
                            break;
                    }
                }



                this.wellDispositionLegacyTrackingDomainValues$ = this.domainService.getValues(this.wellDispositionLegacyTrackingDomainId);

                if (this.wellDispositionLegacyTrackingDomainId != null)
                    this.loadWellDispositionLegacyTrackingData();
            }

            if (this._well.wellStatus && this._well.wellStatus.type) {
                switch (this._well.wellStatus.type.type) {
                    case "OG_R":
                        this.wellTypeDescriptionDomainId = "OilAndGasWellTypeDescriptions";
                        break;
                    case "ER_R":
                        this.wellTypeDescriptionDomainId = "EnhancedRecoveryWellTypeDescriptions";
                        break;
                    case "SW_R":
                        this.wellTypeDescriptionDomainId = "DisposalWellTypeDescriptions";
                        break;
                    case "UN_R":
                        this.wellTypeDescriptionDomainId = "UnknownWellTypeDescriptions";
                        break;
                }

                if (this._well.wellStatus.type.description) {
                    this.form.get("wellTypeDesc").setValue(this._well.wellStatus.type.description)
                }
            }

            if (this._well.wellStatus.legacyTracking) {
                this.form.get("legacyTracking").setValue(this._well.wellStatus.legacyTracking);
            }

            if (this._well.mapSymbol) {
                this.form.get("wellSymbol").setValue(this._well.mapSymbol);
            }

        }


        else if (this._well != null) {
            if (this._well.wellStatus && this._well.wellStatus.disposition) {
                if (this._well.wellStatus.disposition != null) {
                    this.form.get("disposition").setValue(this._well.wellStatus.disposition);
                    switch (this._well.wellStatus.disposition) {
                        case "DG":
                            this.wellDispositionLegacyTrackingDomainId = "WellSpuddedLegacyTrackingOptions";
                            break;
                        case "DR":
                            this.wellDispositionLegacyTrackingDomainId = "WellDrilledLegacyTrackingOptions";
                            break;
                        case "FR":
                            this.wellDispositionLegacyTrackingDomainId = "FinalRestorationLegacyTrackingOptions";
                            break;
                        case "PA":
                            this.wellDispositionLegacyTrackingDomainId = "PluggedLegacyTrackingOptions";
                            break;
                        case "PR":
                            this.wellDispositionLegacyTrackingDomainId = "ProductionStartedLegacyTrackingOptions";
                            break;
                        case "ORPH":
                            this.wellDispositionLegacyTrackingDomainId = "OrphanLegacyTrackingOptions";
                            break;
                        case "UN":
                            this.wellDispositionLegacyTrackingDomainId = "UnknownLegacyTrackingOptions";
                            break;
                    }
                }

                if (this._well.wellStatus.legacyTracking) {
                    this.form.get("legacyTracking").setValue(this._well.wellStatus.legacyTracking);
                }

                this.wellDispositionLegacyTrackingDomainValues$ = this.domainService.getValues(this.wellDispositionLegacyTrackingDomainId);

                if (this.wellDispositionLegacyTrackingDomainId != null)
                    this.loadWellDispositionLegacyTrackingData();
            }

            if (this._well.wellStatus && this._well.wellStatus.type) {
                switch (this._well.wellStatus.type.type) {
                    case "OG_R":
                        this.wellTypeDescriptionDomainId = "OilAndGasWellTypeDescriptions";
                        break;
                    case "ER_R":
                        this.wellTypeDescriptionDomainId = "EnhancedRecoveryWellTypeDescriptions";
                        break;
                    case "SW_R":
                        this.wellTypeDescriptionDomainId = "DisposalWellTypeDescriptions";
                        break;
                    case "UN_R":
                        this.wellTypeDescriptionDomainId = "UnknownWellTypeDescriptions";
                        break;
                }

                if (this._well.wellStatus.type.description) {
                    this.form.get("wellTypeDesc").setValue(this._well.wellStatus.type.description)
                }
            }

            if (this._well.mapSymbol) {
                this.form.get("wellSymbol").setValue(this._well.mapSymbol);
            }
        }

        this.wellTypeDescriptionDomainValues$ = this.domainService.getValues(this.wellTypeDescriptionDomainId);

        this.wellDispositionDomainValues$ = this.domainService.getValues("STATUS_DESC")

        if (this.wellTypeDescriptionDomainId != null)
            this.loadWellTypeDescriptionData();

        this.loadWellDispositionData();
        if (this.application != null && this.applicationState == ApplicationState.Approved) {
            this.form.disable();
        }


    }

    loadWellDispositionLegacyTrackingData() {
        //Fetch the well disposition legacy tracking domain values, if applicable
        if (this.wellDispositionLegacyTrackingDomainId != null) {
            this.subscriptions.add(this.wellDispositionLegacyTrackingDomainValues$.pipe(
            ).subscribe(
                (domainValues: DomainValue[]) => {
                    if (domainValues)
                        this._legacyTrackingValues = domainValues;
                },
                error => { console.error(error); console.error("ERROR Fetching the " + this.wellDispositionLegacyTrackingDomainId + " domain for this well."); }
            ));
        }
    }

    loadWellTypeDescriptionData() {
        //Fetch the well type description domain values, if applicable
        if (this.wellTypeDescriptionDomainId != null) {
            this.subscriptions.add(this.wellTypeDescriptionDomainValues$.pipe(
            ).subscribe(
                (domainValues: DomainValue[]) => {
                    if (domainValues)
                        this.wellTypeDescriptionDomainValues = domainValues;
                },
                error => { console.error(error); console.error("ERROR Fetching the " + this.wellTypeDescriptionDomainId + " domain for this well."); }
            ));
        }
    }

    loadWellDispositionData() {
        if (this._dispositionOptions == null) {
            this.subscriptions.add(this.wellDispositionDomainValues$.pipe().subscribe(
                (domainValues: DomainValue[]) => {
                    if (domainValues) {
                        this._dispositionOptions = domainValues;
                    }
                },
                error => console.error(error)
            ));

        }
    }


    getDispositionLegacyTrackingOptions$(): Observable<any[]> {
        let spudded$: Observable<any> = this.domainService.getValues("WellSpuddedLegacyTrackingOptions").pipe(
            map((data: DomainValue[]) => {           
                return data;
            })
        );

        let drilled$: Observable<any>= this.domainService.getValues("WellDrilledLegacyTrackingOptions").pipe(
            map((data: DomainValue[]) => {              
                return data;
            })
        );

        let restoration$: Observable<any> = this.domainService.getValues("FinalRestorationLegacyTrackingOptions").pipe(
            map((data: DomainValue[]) => {
             
                return data;
            })
        );

        let plugged$: Observable<any> = this.domainService.getValues("PluggedLegacyTrackingOptions").pipe(
            map((data: DomainValue[]) => {
               
                return data;
            })
        );

        let production$: Observable<any> = this.domainService.getValues("ProductionStartedLegacyTrackingOptions").pipe(
            map((data: DomainValue[]) => {
             
                return data;
            })
        );

        let orphan$: Observable<any> = this.domainService.getValues("OrphanLegacyTrackingOptions").pipe(
            map((data: DomainValue[]) => {
              
                return data;
            })
        );

        let unknown$: Observable<any> = this.domainService.getValues("UnknownLegacyTrackingOptions").pipe(
            map((data: DomainValue[]) => {
            
                return data;
            })
        );

        return forkJoin([spudded$, drilled$, restoration$, plugged$, production$, orphan$, unknown$]).pipe(
            tap((sets: DomainValue[]) => {
                this._dispositionOptions = sets;

            })
        );
    }

    onChange(event: string) {
        if (this.form.get('disposition').value != null) {
            switch (event) {
                case "DG":
                    this.wellDispositionLegacyTrackingDomainId = "WellSpuddedLegacyTrackingOptions";
                    break;
                case "DR":
                    this.wellDispositionLegacyTrackingDomainId = "WellDrilledLegacyTrackingOptions";
                    break;
                case "FR":
                    this.wellDispositionLegacyTrackingDomainId = "FinalRestorationLegacyTrackingOptions";
                    break;
                case "PA":
                    this.wellDispositionLegacyTrackingDomainId = "PluggedLegacyTrackingOptions";
                    break;
                case "PR":
                    this.wellDispositionLegacyTrackingDomainId = "ProductionStartedLegacyTrackingOptions";
                    break;
                case "ORPH":
                    this.wellDispositionLegacyTrackingDomainId = "OrphanLegacyTrackingOptions";
                    break;
                case "UN":
                    this.wellDispositionLegacyTrackingDomainId = "UnknownLegacyTrackingOptions";
                    break;
            }
        }

        if (this.wellDispositionLegacyTrackingDomainId != null) {


            this.wellDispositionLegacyTrackingDomainValues$ = this.domainService.getValues(this.wellDispositionLegacyTrackingDomainId);
            this.loadWellDispositionLegacyTrackingData();
        }

        else {
            this._legacyTrackingValues = [];
        }

    }


}
